var _desc, _defs, _mask, _g, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _mask2, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevvModern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "905px",
    height: "300px",
    viewBox: "0 0 905 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M145.427191,278.225266 L95.399813,298.388402 C90.2781745,300.452638 84.4466074,298.037012 82.2848634,292.955761 L59.5263872,239.461205 L6.14068228,216.643249 C1.07496867,214.478077 -1.3335835,208.663026 0.717590405,203.55009 L20.861893,153.336639 C21.8335055,150.914713 21.8335055,148.211349 20.861893,145.789423 L0.717590405,95.5759722 C-1.3335835,90.4630367 1.07496867,84.6479859 6.14068228,82.4828139 L55.7789414,61.2665796 C58.1836743,60.2387559 60.0980334,58.3211843 61.1218235,55.9147315 L82.2848634,6.17030167 C84.4466074,1.08905063 90.2781745,-1.32657546 95.399813,0.737660093 L145.427191,20.900796 C147.858009,21.8805179 150.57384,21.8805179 153.004658,20.900796 L203.032037,0.737660093 C208.153675,-1.32657546 213.985242,1.08905063 216.146986,6.17030167 L237.310026,55.9147315 C238.333816,58.3211843 240.248175,60.2387559 242.652908,61.2665796 L292.291167,82.4828139 C297.356881,84.6479859 299.765433,90.4630367 297.714259,95.5759722 L277.569957,145.789423 C276.598344,148.211349 276.598344,150.914713 277.569957,153.336639 L297.714259,203.55009 C299.765433,208.663026 297.356881,214.478077 292.291167,216.643249 L242.652908,237.859483 C240.248175,238.887307 238.333816,240.804878 237.310026,243.211331 L216.146986,292.955761 C213.985242,298.037012 208.153675,300.452638 203.032037,298.388402 L153.004658,278.225266 C150.57384,277.245545 147.858009,277.245545 145.427191,278.225266 Z M149.788843,220.061651 L184.460006,234.035587 L199.118088,199.581277 L233.492436,184.889098 L219.550931,150.137282 L233.492436,115.385466 L199.118088,100.693286 L184.460006,66.2389768 L149.788843,80.2129129 L115.117679,66.2389768 L100.459597,100.693286 L66.0852491,115.385466 L80.0267545,150.137282 L66.0852491,184.889098 L100.459597,199.581277 L115.117679,234.035587 L149.788843,220.061651 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283AC5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-4",
    points: "169.189012 165.305389 169.958242 284.359435 51.718883 285.000886"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "143.039723 108.950326 143.912027 225.417085 26.3167223 226.565157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "2.17917531%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283AC5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "169.219135 167.392074 51.1704369 167.756641 49.2928467 49.6938906"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283AC5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "226.798675 142.488619 109.008328 143.03828 108.600633 24.6167546"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-10",
    points: "285.032108 165.868197 167.779483 166.361715 167.690238 48.8736758"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-11",
    points: "309.86945 223.752928 192.616824 224.246446 192.52758 106.758406"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-12",
    points: "285.98199 282.553396 168.729364 283.046913 168.64012 165.558874"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-13",
    points: "228.174453 307.668223 110.921828 308.16174 110.832584 190.673701"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.427191,278.225266 L95.399813,298.388402 C90.2781745,300.452638 84.4466074,298.037012 82.2848634,292.955761 L59.5263872,239.461205 L6.14068228,216.643249 C1.07496867,214.478077 -1.3335835,208.663026 0.717590405,203.55009 L20.861893,153.336639 C21.8335055,150.914713 21.8335055,148.211349 20.861893,145.789423 L0.717590405,95.5759722 C-1.3335835,90.4630367 1.07496867,84.6479859 6.14068228,82.4828139 L55.7789414,61.2665796 C58.1836743,60.2387559 60.0980334,58.3211843 61.1218235,55.9147315 L82.2848634,6.17030167 C84.4466074,1.08905063 90.2781745,-1.32657546 95.399813,0.737660093 L145.427191,20.900796 C147.858009,21.8805179 150.57384,21.8805179 153.004658,20.900796 L203.032037,0.737660093 C208.153675,-1.32657546 213.985242,1.08905063 216.146986,6.17030167 L237.310026,55.9147315 C238.333816,58.3211843 240.248175,60.2387559 242.652908,61.2665796 L292.291167,82.4828139 C297.356881,84.6479859 299.765433,90.4630367 297.714259,95.5759722 L277.569957,145.789423 C276.598344,148.211349 276.598344,150.914713 277.569957,153.336639 L297.714259,203.55009 C299.765433,208.663026 297.356881,214.478077 292.291167,216.643249 L242.652908,237.859483 C240.248175,238.887307 238.333816,240.804878 237.310026,243.211331 L216.146986,292.955761 C213.985242,298.037012 208.153675,300.452638 203.032037,298.388402 L153.004658,278.225266 C150.57384,277.245545 147.858009,277.245545 145.427191,278.225266 Z M149.788843,220.061651 L184.460006,234.035587 L199.118088,199.581277 L233.492436,184.889098 L219.550931,150.137282 L233.492436,115.385466 L199.118088,100.693286 L184.460006,66.2389768 L149.788843,80.2129129 L115.117679,66.2389768 L100.459597,100.693286 L66.0852491,115.385466 L80.0267545,150.137282 L66.0852491,184.889098 L100.459597,199.581277 L115.117679,234.035587 L149.788843,220.061651 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.427191,278.225266 L95.399813,298.388402 C90.2781745,300.452638 84.4466074,298.037012 82.2848634,292.955761 L59.5263872,239.461205 L6.14068228,216.643249 C1.07496867,214.478077 -1.3335835,208.663026 0.717590405,203.55009 L20.861893,153.336639 C21.8335055,150.914713 21.8335055,148.211349 20.861893,145.789423 L0.717590405,95.5759722 C-1.3335835,90.4630367 1.07496867,84.6479859 6.14068228,82.4828139 L55.7789414,61.2665796 C58.1836743,60.2387559 60.0980334,58.3211843 61.1218235,55.9147315 L82.2848634,6.17030167 C84.4466074,1.08905063 90.2781745,-1.32657546 95.399813,0.737660093 L145.427191,20.900796 C147.858009,21.8805179 150.57384,21.8805179 153.004658,20.900796 L203.032037,0.737660093 C208.153675,-1.32657546 213.985242,1.08905063 216.146986,6.17030167 L237.310026,55.9147315 C238.333816,58.3211843 240.248175,60.2387559 242.652908,61.2665796 L292.291167,82.4828139 C297.356881,84.6479859 299.765433,90.4630367 297.714259,95.5759722 L277.569957,145.789423 C276.598344,148.211349 276.598344,150.914713 277.569957,153.336639 L297.714259,203.55009 C299.765433,208.663026 297.356881,214.478077 292.291167,216.643249 L242.652908,237.859483 C240.248175,238.887307 238.333816,240.804878 237.310026,243.211331 L216.146986,292.955761 C213.985242,298.037012 208.153675,300.452638 203.032037,298.388402 L153.004658,278.225266 C150.57384,277.245545 147.858009,277.245545 145.427191,278.225266 Z M149.788843,220.061651 L184.460006,234.035587 L199.118088,199.581277 L233.492436,184.889098 L219.550931,150.137282 L233.492436,115.385466 L199.118088,100.693286 L184.460006,66.2389768 L149.788843,80.2129129 L115.117679,66.2389768 L100.459597,100.693286 L66.0852491,115.385466 L80.0267545,150.137282 L66.0852491,184.889098 L100.459597,199.581277 L115.117679,234.035587 L149.788843,220.061651 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-18",
    points: "169.189012 165.305389 169.958242 284.359435 51.718883 285.000886"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-19",
    points: "143.039723 108.950326 143.912027 225.417085 26.3167223 226.565157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-21",
    points: "169.219135 167.392074 51.1704369 167.756641 49.2928467 49.6938906"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-22",
    points: "226.798675 142.488619 109.008328 143.03828 108.600633 24.6167546"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-23",
    points: "285.032108 165.868197 167.779483 166.361715 167.690238 48.8736758"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-24",
    points: "309.86945 223.752928 192.616824 224.246446 192.52758 106.758406"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-25",
    points: "285.98199 282.553396 168.729364 283.046913 168.64012 165.558874"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-26",
    points: "228.174453 307.668223 110.921828 308.16174 110.832584 190.673701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Brand",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    transform: "translate(-3474.000000, -670.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(3474.000000, 670.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#3B64F1",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5969E2",
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    opacity: 0.5,
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.873978, 150.452017) rotate(23.000000) translate(-148.873978, -150.452017) translate(-18.340787, -16.777712)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("g", null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#5969E2",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-3)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.114375, 167.757742) rotate(-315.000000) translate(-85.114375, -167.757742) "
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#5969E2",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-3)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", null, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    fill: "#5969E2",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-6)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.699654, 83.827517) rotate(-315.000000) translate(-167.699654, -83.827517) "
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    fill: "#5969E2",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-8)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.361173, 107.617695) rotate(-270.000000) translate(-226.361173, -107.617695) "
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    fill: "#5969E2",
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-8)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(251.198515, 165.502426) rotate(-225.000000) translate(-251.198515, -165.502426) "
  }, _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    fill: "#5969E2",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-8)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.311055, 224.302894) rotate(-180.000000) translate(-227.311055, -224.302894) "
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    fill: "#5969E2",
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-8)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(169.503519, 249.417721) rotate(-135.000000) translate(-169.503519, -249.417721) "
  }, _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    fill: "#5969E2",
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-8)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-13"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    opacity: 0.482959692,
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-14"
  }), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    fill: "#6981EF",
    xlinkHref: "#path-14"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    opacity: 0.340000004
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  }))), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#3542E8",
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    mask: "url(#mask-16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.873978, 150.452017) rotate(23.000000) translate(-148.873978, -150.452017) translate(-18.340787, -16.777712)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("g", null, _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    fill: "#4362FF",
    xlinkHref: "#path-18"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-17)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-18"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.114375, 167.757742) rotate(-315.000000) translate(-85.114375, -167.757742) "
  }, _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    fill: "#4362FF",
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-17)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", null, _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    fill: "#4362FF",
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-20)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.699654, 83.827517) rotate(-315.000000) translate(-167.699654, -83.827517) "
  }, _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    fill: "#4362FF",
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-20)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.361173, 107.617695) rotate(-270.000000) translate(-226.361173, -107.617695) "
  }, _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    fill: "#4362FF",
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-20)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(251.198515, 165.502426) rotate(-225.000000) translate(-251.198515, -165.502426) "
  }, _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    fill: "#4362FF",
    xlinkHref: "#path-24"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-20)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-24"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.311055, 224.302894) rotate(-180.000000) translate(-227.311055, -224.302894) "
  }, _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    fill: "#4362FF",
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-20)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(169.503519, 249.417721) rotate(-135.000000) translate(-169.503519, -249.417721) "
  }, _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    fill: "#4362FF",
    xlinkHref: "#path-26"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#linearGradient-20)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-26"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M419.806002,168.804515 L419.806002,221.426935 L393.208054,221.426935 L393.208054,79.0540541 L419.806002,79.0540541 L419.806002,112.673934 C426.52856,90.1632317 439.096821,79.0540541 457.803071,79.0540541 C475.67371,79.0540541 483.171366,84.2557712 487.442183,87.3162765 C481.707205,93.3007255 476.8387,99.9857075 472.836667,107.371223 C466.406394,104.155408 461.581798,104.488224 457.2185,104.488224 C432.374263,104.488224 419.806002,130.21474 419.806002,168.804515 Z M508.319687,139.569837 L593.082379,139.569837 C589.867243,117.059135 573.79156,103.02649 551.577889,103.02649 C528.487362,103.02649 511.534824,117.059135 508.319687,139.569837 Z M619.388042,149.801975 C619.388042,154.77187 619.388042,158.280031 619.095757,160.326459 L508.319687,160.326459 C511.534824,182.837161 529.071932,197.4545 552.454744,197.4545 C569.114997,197.4545 584.313825,189.561137 591.620953,176.405531 C594.25152,177.282572 598.051227,179.036652 603.312359,181.08308 L614.419195,185.175935 C603.020074,208.563677 578.760407,221.426935 551.577889,221.426935 C531.702499,221.426935 515.042245,214.702959 501.597129,201.547354 C488.444297,188.391749 481.721739,171.143289 481.721739,149.801975 C481.721739,128.46066 488.444297,111.504547 501.597129,98.6412882 C515.042245,85.4856832 531.702499,79.0540541 551.577889,79.0540541 C571.160993,79.0540541 587.528961,85.4856832 600.097223,98.6412882 C612.957769,111.504547 619.388042,128.46066 619.388042,149.801975 Z M701.325312,221.426935 L701.471454,221.426935 L701.325312,221.426935 Z M675.750361,221.426935 L619.047043,79.0540541 L647.106417,79.0540541 L688.610908,184.591241 L729.823113,79.0540541 L758.174772,79.0540541 L701.179169,221.426935 L675.750361,221.426935 Z M847.711456,221.426935 L847.857598,221.426935 L847.711456,221.426935 Z M822.136505,221.426935 L765.433187,79.0540541 L793.492561,79.0540541 L834.997052,184.591241 L876.209257,79.0540541 L904.560916,79.0540541 L847.565313,221.426935 L822.136505,221.426935 Z",
    id: "revv",
    fill: "#191E2A"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevvModern);
export default __webpack_public_path__ + "static/media/revv_modern.aa39acd4dd561fecf25b27bcb25eac9d.svg";
export { ForwardRef as ReactComponent };